// components/SearchBox.js
import React, { useState } from 'react';
import { Box, InputGroup, Input, InputRightElement, useColorMode, Icon } from '@chakra-ui/react';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { StandaloneSearchBox } from '@react-google-maps/api';

const SearchBox = ({ onPlacesChanged, onLoad }) => {
  const { colorMode } = useColorMode();
  const [searchValue, setSearchValue] = useState('');

  const handleInputChange = (e) => {
    setSearchValue(e.target.value || ''); // Ensure empty string if null/undefined
  };

  return (
    <Box mb={4}>
      <StandaloneSearchBox onLoad={onLoad} onPlacesChanged={onPlacesChanged}>
        <InputGroup>
          <Input
            placeholder="Search for a location..."
            value={searchValue}
            onChange={handleInputChange}
            bg={colorMode === 'dark' ? 'gray.700' : 'white'}
            color={colorMode === 'dark' ? 'white' : 'black'}
            borderColor={colorMode === 'dark' ? 'gray.600' : 'gray.200'}
            _hover={{
              borderColor: colorMode === 'dark' ? 'gray.500' : 'gray.300'
            }}
            _focus={{ 
              borderColor: 'blue.500',
              boxShadow: 'none'
            }}
            aria-label="Search for a location"
          />
          <InputRightElement>
            <Icon as={MagnifyingGlass} color={colorMode === 'dark' ? 'gray.400' : 'gray.500'} />
          </InputRightElement>
        </InputGroup>
      </StandaloneSearchBox>
    </Box>
  );
};

export default React.memo(SearchBox);
